<template>
  <zr-base-layout
    :routes="routes"
    :visited-routes="visitedRoutes"
    :ad-list="adList"
    :copyright="copyright"
    :title="title"
    :logo="logo"
    :need-login="needLogin"
    :device="device"
    :route-change="routeChange"
    :tab-remove-call-back="tabRemoveCallBack"
    :tab-click-call-back="tabClickCallBack"
    :tab-init-call-back="tabInitCallBack"
    :tab-add-call-back="tabAddCallBack"
    :close-selected-tag-c-b="closeSelectedTagCB"
    :close-others-tags-c-b="closeOthersTagsCB"
    :close-left-tags-c-b="closeLeftTagsCB"
    :close-right-tags-c-b="closeRightTagsCB"
    :close-all-tags-c-b="closeAllTagsCB"
    :collapse="collapse"
    :default-oopeneds="defaultOopeneds"
    :unique-opened="uniqueOpened"
    :clear-all-call-back="clearAllCallBack"
    :error-logs="errorLogs"
    :default-layout="defaultLayout"
    :layout="layout"
    :header="header"
    :tags-bar="tagsBar"
    :theme-bar="themeBar"
    :change-layout-call-back="changeLayoutCallBack"
    :set-theme-call-back="setThemeCallBack"
    :personal-call-back="personalCallBack"
    :logout-call-back="logoutCallBack"
    :collapse-change-call-back="collapseChangeCallBack"
    :link-click-call-back="linkClickCallBack"
    :username="username"
    :show-ad="showAd"
    :show-side-bar="showSideBar"
    :register-call-back="registerCallBack"
    :login-call-back="loginCallBack"
    :show-personal="false"
    :logo-path="logoPath"
    :org-title="orgTitle"
    :show-modify-pass="curRole != 'user'"
    :modify-password-call-back="modifyPasswordCallBack"
    :goto-home-call-back="gotoHomeCallBack"
  ></zr-base-layout>
</template>

<script>
import {
  copyright,
  title,
  defaultOopeneds,
  uniqueOpened,
  recordRoute,
  layout as defaultLayout,
  showAd,
  showSideBar,
  orgTitle,
} from "@/config/settings";
import { isExternal } from "zr-util/src/utils/comm/validate";
import { mapGetters } from "vuex";
import path from "path";
export default {
  name: "Index",
  data() {
    return {
      showAll: true,
      showSideBar: showSideBar,
      showAd: showAd,
      adList: undefined,
      copyright: copyright,
      title: title,
      defaultOopeneds: defaultOopeneds,
      uniqueOpened: uniqueOpened,
      defaultLayout: defaultLayout,
      logoPath: "assets/zr/images/login_logo.png",
      orgTitle: orgTitle,
    };
  },
  computed: {
    ...mapGetters({
      routes: "routes/routes",
      visitedRoutes: "tagsBar/visitedRoutes",
      device: "settings/device",
      skeleton: "settings/skeleton",
      collapse: "settings/collapse",
      errorLogs: "errorLog/errorLogs",
      layout: "settings/layout",
      header: "settings/header",
      tagsBar: "settings/tagsBar",
      themeBar: "settings/themeBar",
      username: "user/userName",
      curRole: "user/curRole",
      logo: "settings/logo",
      needLogin: "user/needLogin",
    }),
  },
  async created() {
    await this.getAdList();
  },
  methods: {
    registerCallBack() {
      this.$router.push("/register");
    },
    loginCallBack() {
      this.$router.push("/login");
    },
    modifyPasswordCallBack() {
      this.$router.push("/modifyPassword/index");
    },
    gotoHomeCallBack() {
      this.$router.push("/");
    },
    async getAdList() {
      this.adList = [];
    },
    routeChange(device) {
      if ("mobile" === device) {
        this.$store.dispatch("settings/foldSideBar");
      }
    },
    async tabRemoveCallBack(view) {
      const { visitedRoutes } = await this.$store.dispatch(
        "tagsBar/delRoute",
        view
      );
      return { visitedRoutes };
    },
    tabClickCallBack(path, query, fullPath) {
      if (this.$route.path !== path) {
        this.$router.push({
          path: path,
          query: query,
          fullPath: fullPath,
        });
      } else {
        return false;
      }
    },
    tabInitCallBack(affixTags) {
      for (const tag of affixTags) {
        if (tag.name) {
          this.$store.dispatch("tagsBar/addVisitedRoute", tag);
        }
      }
    },
    tabAddCallBack(route) {
      this.$store.dispatch("tagsBar/addVisitedRoute", route);
    },
    async closeSelectedTagCB(view) {
      const { visitedRoutes } = await this.$store.dispatch(
        "tagsBar/delRoute",
        view
      );
      return { visitedRoutes };
    },
    async closeOthersTagsCB(view) {
      await this.$store.dispatch("tagsBar/delOthersRoutes", view);
    },
    async closeLeftTagsCB(view) {
      await this.$store.dispatch("tagsBar/delLeftRoutes", view);
    },
    async closeRightTagsCB(view) {
      await this.$store.dispatch("tagsBar/delRightRoutes", view);
    },
    async closeAllTagsCB(view) {
      const { visitedRoutes } = await this.$store.dispatch(
        "tagsBar/delAllRoutes"
      );
      return { visitedRoutes };
    },
    clearAllCallBack() {
      this.$store.dispatch("errorLog/clearErrorLog");
    },
    changeLayoutCallBack(defaultLayout) {
      this.$store.dispatch("settings/changeLayout", defaultLayout);
    },
    setThemeCallBack(layout, header, tagsBar, isMobile) {
      if (!isMobile) {
        this.$store.dispatch("settings/changeLayout", layout);
      }
      this.$store.dispatch("settings/changeHeader", header);
      this.$store.dispatch("settings/changeTagsBar", tagsBar);
    },
    personalCallBack() {
      this.$router.push("/personalCenter/personalCenter");
    },
    async logoutCallBack() {
      await this.$store.dispatch("user/logout");
      if (recordRoute) {
        const fullPath = this.$route.fullPath;
        this.$router.push(`/login?redirect=${fullPath}`);
      } else {
        this.$router.push("/login");
      }
    },
    collapseChangeCallBack() {
      this.$store.dispatch("settings/changeCollapse");
    },
    linkClickCallBack(target, routePath, basePath) {
      if (target === "_blank") {
        if (isExternal(routePath)) {
          window.open(routePath);
        }
        if (isExternal(basePath)) {
          window.open(routePath);
        }
        let routeData = this.$router.resolve(path.resolve(basePath, routePath));
        window.open(routeData.href);
      } else {
        if (isExternal(routePath)) {
          window.location.href = routePath;
        }
        if (isExternal(this.basePath)) {
          window.location.href = routePath;
        }
        this.$router.push(path.resolve(basePath, routePath));
      }
    },
  },
};
</script>

<style scoped></style>
